<template>
  <div class="report">
    <Head></Head>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="dqwz">当前位置：</el-breadcrumb-item>

      <el-breadcrumb-item :to="{ path: '/my' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/my?active=我的报名' }">我的报名</el-breadcrumb-item>
      <el-breadcrumb-item class="zpgg">成绩查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="tac">
      <Process></Process>
      <!-- 右边内容 -->
      <el-col :span="18" class="conter">
        <div id="printTest">
          <h2>
            安徽省环安人才服务有限公司
            <p>{{ data.post_name }}招聘</p>
          </h2>
          <div class="report_box">
            <h3>{{ this.iswritten == 1 ? "笔试成绩单" : "综合成绩单" }}</h3>

            <ul class="report_box_ul">
              <li>考生姓名：{{ data.real_name }}</li>
              <li>
                性&emsp;&emsp;别：<span v-if="data.sex == 1">男</span
                ><span v-if="data.sex == 2">女</span>
              </li>
              <li>证件号码：{{ data.id_card }}</li>
              <li>准考证号：{{ data.zkz_num }}</li>
              <li class="box_li">
                <span>报考岗位：{{ data.post_name }}</span
                ><span>岗位编号：{{ data.post_name }}</span>
              </li>
              <li>笔试成绩：{{ data.written_test_score }} 分</li>
              <li v-if="this.iswritten != 1">
                面试成绩：{{ data.interview_score }} 分
              </li>
              <li v-if="this.iswritten != 1">
                综合成绩：{{ data.composite_score }} 分
              </li>
            </ul>
          </div>
        </div>
        <div class="btm">
          <button v-print="'#printTest'">打印</button>
        </div>
      </el-col>
    </el-row>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
import Process from "./Process";
export default {
  props: {},
  data() {
    return {
      data: {},
      iswritten: 0, //是否是笔试成绩
    };
  },
  computed: {},
  created() {},
  mounted() {
    var query = this.$route.query;
    const post_id = query.post_id;
    var iswritten = query.iswritten;
    var code = 106;
    if (iswritten == "1") {
      this.iswritten = 1;
      code = 104;
    }
    this.getInfo(post_id, code);
  },
  watch: {},
  methods: {
    getInfo(id, code) {
      let _this = this;
      _this
        .request("/api/post_up_info", { post_id: id, code: code }, "get")
        .then((res) => {
          _this.data = res.data.data.info;
        });
    },
  },
  components: {
    Head,
    Footer,
    Process,
  },
};
</script>

<style lang="less" scoped>
.report {
  .tac {
    .conter {
      .btm {
        text-align: center;
        padding: 0.8rem 0;
        button {
          width: 3.28rem;
          height: 0.78rem;
          background-color: #00a0e9;
          color: #fff;
          font-size: 0.37rem;
          border-radius: 0.1rem;
        }
      }
    }
  }
}
h2 {
  font-size: 0.3rem;
  color: #00a0e9;
  text-align: center;
}
.report_box > h3 {
  font-size: 0.3rem;
  text-align: center;
  margin-bottom: 0.5rem;
}
.report_box_ul {
  padding: 0 0.8rem;
}
.report_box_ul > li {
  font-size: 0.16rem;
  padding: 0.15rem 0;
}
.box_li {
  display: flex;
}
.box_li span {
  flex: 0.5;
}
.box_li span:nth-of-type(2) {
  flex: 1;
}
</style>
